// Detecta si la URL tiene 'www.' o no y devuelve la base correcta
const getBaseURL = () => {
    const currentHost = window.location.hostname; // Obtiene el host actual
    if (currentHost.startsWith('www.')) {
        return 'http://tur.watechdev.com';
    } else {
        return 'https://tur.watechdev.com';
    }
};

const baseURL = getBaseURL(); // Obtiene la URL base correcta

export default baseURL;
